import axios from 'axios';
import { EADMISSION_API_URL } from '../../comm/config';
import { rewriteHeaderIdByUserRole, rewriteOBJ } from '../commlogic';
import { getAuthorization } from '../axios';

const API_HOST = EADMISSION_API_URL;

const POST_LIST = {
  getSpecialtyList: '/specialty/list',
  getWorkflowList: '/workflow/list',
  getSpecialtyDefaultList: '/specialty/default/list',
  saveSpecialtyDefaultList: '/create/specialty/default',
  saveAndBatchSpecialtyDefaultList: '/batch/update/specialty',
  getExistingCode: '/existing/specialty/code',
  createSpecialty: '/create/specialty',
  editWorkflow: '/edit/workflow',
  getSpecialtyWardloc: '/specialty/wardloc',
  getSpecialtyCode: '/specialty/code',
  getSubSpecialtyCode: '/subSpecialty/code',
  updateSpecialty: '/update/specialty',
  getSpecialtyDetail: '/specialty/detail',
  getAdmissionList: '/admission/list',
  getWorkflowDetail: '/workflow/detail',
  getAdmissionDisplay: '/admission/display',
  getAssignWardPendingAssList: '/pendingAssign/list',
  editAdmission: '/admission/edit',
  getSpecialtyAdditionalRemark: '/specialty/additional/remark',
  getTransferInDisplay: '/transferIn/display',
  getRedirectList: '/redirect/list',
  getAssignDisplay: '/assign/display',
  getMdroList: '/mdro/list',
  createRemark: '/create/remark',
  updateRemark: '/update/remark',
  createSpecialAlert: '/create/specialAlert',
  updateSpecialAlert: '/update/specialAlert',
  getActionableAlertList: '/hosp/actionableAlert/list',
  uploadAudioFile: '/upload/audioFile',
  deleteAudioFile: '/del/audioFile',
  updateActionableAlertList: '/update/hospActionableAlert',
  getWardActionableAlertList: '/ward/actionableAlert/list',
  createAlertAlarm: '/create/alertAlarm',
  getAdmissionCount: '/admission/count',
  getTicketWard: '/ticketWard/list',
  sendAdmission: '/admission/send',
  ackAllTicket: '/ticket/ackAll',
  ackTicket: '/ticket/ack',
  getTicketList: '/ticket/list',
  getTicketAudioFile: '/ticket/audioFile',
  saveShareFloderLink: '/save/folder/link',
  checkServer: '/checkServer',
  getHealthCheck: '/checkSystem',
  getAckHistory: '/ticket/ackAdHistory',
  getAckBsHistory: '/ticket/ackBsHistory',
  createSpecialtyRemark: '/create/specialtyRemark',
  deleteSpecialtyRemark: '/delete/specialtyRemark',
  updateSpecialtyRemark: '/update/specialtyRemark',
  getTickets: '/ticket/index',
  getAdmBusstopList: '/admBusstop/list',
  getAEDSettingCubicleList: '/aedPanel/detail',
  updateAEDCubicleList: '/aedPanel/update',
  getAEDViewVisible: '/aedView/visible',
  updateAEDViewVisible: '/aedVisible/update',
  getAEDCubicleList: '/aedCubicle/list',
  getAEDCubicleDetail: '/aedView/detail',
  updateLandingCubicle: '/adCubicle/update',
  assignOrDelPatient: '/aedView/update',
  createTransferInRequest: '/reqIn/create',
  getTransferInDetail: '/reqIn/detail',
  getTransferInList: '/reqIn/list',
  updateTransferInRequest: '/reqIn/update',
  getSOPDSettingCubicleList: '/sopdPanel/detail',
  updateSOPDSettingCubicle: '/sopdPanel/update',
  getSOPDViewVisible: '/sopdView/visible',
  updateSOPDViewVisible: '/sopdVisible/update',
  assignOrDelSOPDPatient: '/sopdView/update',
  getSOPDCubicleDetail: '/sopdView/detail',
  getSOPDCubicleList: '/sopdCubicle/list',
  getTransferInVisible: '/reqInView/visible',
  updateTransferInVisible: '/reqInVisible/update',
  getDeclineRedirectList: '/reqIn/redirect',
};

const GET_LIST = {
  getAssignedTitle: '/assigned/title',
  getPorterList: '/porter/dispatch/list',
  getAdmissionDetail: '/admission/detail',
  getCallingCalled: '/callingCalled/list',
  getSpecialty: '/admSpecialty/list',
  getAdmWard: '/admWard/list',
  getHospSpec: '/hospSpec/list',
  getRemarkList: '/remark/list',
  getSpecialAlertList: '/specialAlert/list',
  getAlertDropdownList: '/alert/drpdwnlist',
  getTicketHistory: '/ticket/ackHistory',
  getShareFloderLink: '/folder/link/detail',
  getSpecialtyRemarkList: '/specialtyRemark/list',
  getIsolationRoomList: '/isolationRoom/list',
  getHospWardList: '/reqIn/hospWard',
};

const EADMISSIONAPI = {
  POST: POST_LIST,
  GET: GET_LIST,
};

rewriteOBJ(EADMISSIONAPI, API_HOST);

const getAdmissionTIExportRequest = (params) => {
  const revampHeaders = rewriteHeaderIdByUserRole();
  return axios({
    method: 'post',
    url: `${API_HOST}/reqIn/export`,
    responseType: 'blob',
    headers: { ...revampHeaders, Authorization: getAuthorization()?.Authorization || '' },
    data: params,
  });
};
const getAdmissionExportRequest = (params) => {
  const revampHeaders = rewriteHeaderIdByUserRole();
  return axios({
    method: 'post',
    url: `${API_HOST}/admission/export`,
    responseType: 'blob',
    headers: { ...revampHeaders, Authorization: getAuthorization()?.Authorization || '' },
    data: params,
  });
};

const getTicketExportRequest = (params) => {
  return axios({
    method: 'post',
    url: `${API_HOST}/ticket/export`,
    responseType: 'blob',
    data: params,
  });
};
const getBsTicketExportRequest = (params) => {
  return axios({
    method: 'post',
    url: `${API_HOST}/bsTicket/export`,
    responseType: 'blob',
    data: params,
  });
};

export default {
  ...EADMISSIONAPI.GET,
  ...EADMISSIONAPI.POST,
  getAdmissionExportRequest,
  getTicketExportRequest,
  getBsTicketExportRequest,
  getAdmissionTIExportRequest,
};
